module.exports = __webpack_public_path__ + "img/logo1.bc3af1cf.jpg";